module.exports = __webpack_public_path__ + "a0d87eb433ec27456153abe18fd9df13.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/opher-vishnia.jpg
// module id = 522
// module chunks = 0